module.exports = __webpack_public_path__ + "assets/img/store-banner-06.7b20933b.png";